import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let has_admin = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'current_location.permissions.has_admin',
  })

  let selectedOption = useDataValue({
    context: 'selected',
    path: 'type',
    viewPath: props.viewPath,
  })

  function isSelected(id, selected) {
    if ((selected === 'PUBLIC' || selected === 'HIDDEN') && id === 'PUBLIC') {
      return true
    } else if (selected === 'PRIVATE' && id === 'PRIVATE') {
      return true
    } else {
      return false
    }
  }

  function isDisabled(id, has_admin) {
    return id !== 'PRIVATE' && !has_admin
  }

  return useMemo(() => {
    return data.map(item => ({
      ...item,
      isSelected: isSelected(item.id, selectedOption),
      isDisabled: isDisabled(item.id, has_admin),
    }))
  }, [data, selectedOption, has_admin])
}
